module.exports = __webpack_public_path__ + "baselogo.svg?4365f039588a46a1e2b8212f7bac8b8b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/baselogo.svg
// module id = 20
// module chunks = 0